import ModulesLoading from "theme/libs/wordpress/content/ModulesLoading";
import React from "react";
import loadable from "@loadable/component";

const MODULES = {
    default: loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/ThreeColumnsLayout"), {
        fallback: (
            <ModulesLoading
                ratio={[360 / 528, null, 768 / 504, 1024 / 200, 1366 / 271]}
                py={["20px", null, null, null, null, "40px"]}
            />
        ),
    }),
};

const ThreeColumnsPlaceholder = ({ content, isFirstModule }) => {
    const ThreeColumnsLayout = MODULES["default"];

    return <ThreeColumnsLayout {...content} />;
};

export default ThreeColumnsPlaceholder;
